<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>角色列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button
          type="success"
          style="margin-left: 8vh"
          icon="el-icon-plus"
          @click="handleNewAdd"
          size="mini"
          >新增角色</el-button
        >
      </div>
    </div>
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="name" label="角色名称" align="center" />
      <el-table-column prop="description" label="角色描述" align="center" />
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="handleClick(scope.row)"
            type="primary"
            size="small"
            icon="el-icon-edit"
          >
            修改
          </el-button>
          <el-button
            @click.native.prevent="singleDel(scope.row, scope.row.id)"
            type="danger"
            size="small"
            icon="el-icon-delete"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.pageSize"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="30%"
      class="global-dialog-position"
      :before-close="getout"
      :lock-scroll="false"
      :append-to-body="true"
    >
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称" prop="url">
              <el-input
                v-model="form.name"
                autocomplete="off"
                placeholder="请输入"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="描述" prop="url">
              <el-input
                v-model="form.description"
                autocomplete="off"
                placeholder="请输入"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="选择权限" prop="url">
              <el-col :span="24">
                <el-tree
                  ref="tree"
                  :data="data"
                  show-checkbox
                  node-key="id"
                  :props="defaultProps"
                  :check-strictly="isCheck"
                  style="margin-top: 1vh"
                  :default-expanded-keys="form.permissions"
                  :default-checked-keys="form.permissions"
                >
                </el-tree>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForms">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
import tableCommon from "../../../mixins/table-common";
import {
  getCompanysList,
  addCompanyData,
  deleteCompany,
  editCompany,
} from "../../api/userMG";
import { getroleList, editrole, addRole, deleteRole } from "../../api/role";
import { getPermissionList } from "../../api/permission";
export default {
  mixins: [tableCommon],
  data() {
    return {
      isCheck: true,
      data: [],
      defaultProps: {
        children: "children",
        label: "display_name",
      },
      regionTypes: [
        {
          label: 1,
          text: "运行",
        },
        {
          label: 0,
          text: "停运",
        },
      ],
      // 请求地址api
      api: {
        list: getroleList,
        add: addRole,
        del: deleteRole,
        edit: editrole,
      },
      // 规则验证
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      // 传参
      form: {
        status: "1",
      },
      // 弹窗标题
      title: "新增",
      addOrEditOpen: false,
      // 查询参数
      searchForm: {
        page: 1,
        pageSize: 15,
      },
      tableData: [],
    };
  },
  mounted() {
    this.getPermissionLists();
  },
  methods: {
    // 获取权限列表
    getPermissionLists() {
      getPermissionList().then((res) => {
        this.data.push(res.data[0]);
        console.log(this.data)
      });
    },
    // 获取树列表数据
    gettreedata() {
      const list = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
      console.log(list);
    },
    // 点击确定按钮
    submitForms() {
      const rolelist = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
      this.form.permissions = rolelist;
      this.submitForm();
    },
    // 重置
    reset() {
      this.form = {
        status: undefined,
        title: undefined,
      };
    },
    // 新增弹窗
    handleNewAdd() {
      this.title = "新增";
      this.reset();
      this.handleAdd();
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([]);
      });
    },
    // 修改弹窗
    handleClick(row) {
      console.log(this.data);
      this.title = "修改";
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([]);
        this.form = JSON.parse(JSON.stringify(row));
      });
      this.handleEdit();
    },
    // 关闭弹窗
    getout() {
      this.addOrEditOpen = false;
      this.$refs.form.clearValidate();
    },
  },
};
</script>

<style scoped>
/deep/ .el-dialog__body {
  height: 40vh;
  overflow-y: auto;
}
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}
.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/views/role/index.vue